import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { ProseContent } from "@/types/report";

interface Props {
  content: ProseContent;
}

export function ProseSection({ content }: Props) {
  return (
    <div className="report-prose">
      <h2>{content.heading}</h2>
      <Markdown remarkPlugins={[remarkGfm]}>{content.text}</Markdown>
    </div>
  );
}
